export default {
  toolbar: {
    position:'absolute', 
    right: 20,
    top: 70,
    zIndex: 1000
  }
}


// WEBPACK FOOTER //
// ./src/config/config.css.js